module.exports = __webpack_public_path__ + "static/media/river.c1e2aa83.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/river.png
// module id = 554
// module chunks = 0